import styled from "styled-components";

export const ForgotPasswordFormStyles = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  .form {
    width: 390px;
    max-width: calc(100vw - 40px);
  }

  .link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.accent[400]};
    font-weight: normal;
  }

  .backToLogin {
    font-weight: normal;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 12px;
    text-align: center;
    margin: 18px 0 0 0;
  }
`;
